export const isGloballyPricelist = (): boolean => {
  if (typeof window !== 'undefined') return window.envs?.isPricelist
  return false
}
